/**
 * Extrait les années distinctes depuis un tableau d'enregistrements de temps,
 * ajoute l'année en cours si elle n'est pas déjà présente,
 * et retourne la liste triée par ordre décroissant.
 *
 * @param {Array} tempsData - Enregistrements de temps Airtable
 * @returns {number[]} Années triées décroissant
 */
export function getAvailableYearsFromTemps(tempsData) {
  const years = new Set(
    (tempsData || []).map(t => t.fields?.Année).filter(Boolean)
  );

  const currentYear = new Date().getFullYear();
  years.add(currentYear);

  return [...years].sort((a, b) => b - a);
}
